import {
  BulkEditFormContainer,
  DataEntryHeaderRow,
  DataEntryRow,
  SelectedDataEntriesConsumer,
} from 'general-ledger';
import React, { Fragment } from 'react';
import { TextBlock } from 'bench-internal-theme';
import { DataEntry, DateRange, GeneralLedgerFilters } from 'general-ledger/types';
import {
  BulkEditFormArea,
  Transaction1099ViewContentArea,
  TableHeading,
} from './Transactions1099View.styles';
import { Button } from 'bench-internal-theme';
import doesDataEntryContainSearchString from 'bk-web-app/transaction-manager/doesDataEntryContainSearchString';
import { Client } from 'bk-web-app/transaction-manager/components/transactions-1099-container/types';
import { AppSidebar } from 'bk-web-app/app-sidebar';
import ManageContractorSidebar from '../manage-contractor-sidebar/ManageContractorSidebar';

const transactions1099ColumnHeaders = [
  { heading: 'Date', width: '80px' },
  { heading: 'Transaction Name', width: 'auto' },
  { heading: 'Debit', width: '80px', align: 'right' },
  { heading: 'Credit', width: '80px', align: 'right' },
  { heading: 'Contractor', width: 'auto' },
  { heading: 'Sources', width: 'auto' },
  { heading: 'Notes', width: 'auto', maxWidth: '300px' },
  {
    heading: 'Has client comments, client categorization response, or internal notes',
    icon: 'speechBubble',
  },
  { heading: 'Client selected this ledger account', icon: 'circleCheck' },
  { heading: 'Has attachment', icon: 'paperclip' },
  { heading: 'Has flagged internal note(s)', icon: 'flagFilled' },
  { heading: 'Add-On', width: '100px' },
];

type Transactions1099ViewProps = {
  search: string;
  selectedDataEntry?: DataEntry;
  transactions1099Entries: Array<DataEntry>;
  toggleDataEntry: (DataEntry) => void;
  availableDataEntriesMap: Map<string, DataEntry>;
  dateRange: DateRange;
  client: Client;
};

const Transactions1099View = ({
  search,
  selectedDataEntry,
  transactions1099Entries,
  toggleDataEntry,
  availableDataEntriesMap,
  dateRange,
  client,
}: Transactions1099ViewProps) => {
  const isSearchStringSet = search.trim() !== '';
  const filter: GeneralLedgerFilters = {};

  return (
    <SelectedDataEntriesConsumer>
      {({ selectedDataEntryIds }: { selectedDataEntryIds: string[] }) => {
        const areAnyDataEntriesSelectedForBulkEdit = !!selectedDataEntryIds.length;
        const dataEntries1099 = transactions1099Entries.filter(dataEntry =>
          isSearchStringSet ? doesDataEntryContainSearchString(dataEntry, search) : true,
        );

        return (
          <Fragment>
            <Transaction1099ViewContentArea aria-label="Transaction 1099 Content Area">
              <TableHeading>
                <TextBlock styleType="title">1099 Transactions</TextBlock>
                <AppSidebar>
                  {({ closeSidebar, openSidebar }) => (
                    <Button
                      size="medium"
                      styleType="primary"
                      onClick={() =>
                        openSidebar(
                          <ManageContractorSidebar
                            openSidebar={openSidebar}
                            dismiss={closeSidebar}
                            clientId={client.id}
                          />,
                        )
                      }
                    >
                      Manage Contractors
                    </Button>
                  )}
                </AppSidebar>
              </TableHeading>
              <DataEntryHeaderRow
                columns={transactions1099ColumnHeaders}
                dataEntriesUnderHeader={dataEntries1099}
                client={client}
              />
              {dataEntries1099.map((dataEntry, index) => (
                <DataEntryRow
                  key={dataEntry.id}
                  index={index}
                  hasBackgroundColor={index % 2}
                  dataEntry={dataEntry}
                  isSelected={!!selectedDataEntry && selectedDataEntry.id === dataEntry.id}
                  showLedgerAccountName
                  search={search}
                  toggleDataEntry={toggleDataEntry}
                  client={client}
                />
              ))}
            </Transaction1099ViewContentArea>
            {areAnyDataEntriesSelectedForBulkEdit && (
              <BulkEditFormArea>
                <BulkEditFormContainer
                  availableDataEntries={dataEntries1099}
                  availableDataEntriesMap={availableDataEntriesMap}
                  client={client}
                  dateRange={dateRange}
                  filters={filter}
                />
              </BulkEditFormArea>
            )}
          </Fragment>
        );
      }}
    </SelectedDataEntriesConsumer>
  );
};

export default Transactions1099View;
